/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_OtherInputs */

const en_wc_dl_other = /** @type {(inputs: Wc_Dl_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FreeBSD & self-hosting`)
};

/**
* | output |
* | --- |
* | "FreeBSD & self-hosting" |
*
* @param {Wc_Dl_OtherInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_other = /** @type {((inputs?: Wc_Dl_OtherInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_OtherInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_other(inputs)
});
export { wc_dl_other as "wc.dl.other" }